import React from "react";
import maheshi from '../assets/maheshi.jpg';
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="responsive-container-block bigContainer">
      <div className="responsive-container-block Container">
       
        <div className="responsive-container-block textSide">
          <p className="text-blk heading">Faculty tutor at Future MedsAcademy</p>
          {/* <h2>My Journey and the Vision Behind Future MedsAcademy</h2> */}
          <p className="text-blk subHeading">
          Maheshi Kasthuriarachchi – Medicine and Surgery student at the University of Messina, Italy.
 With 19 years in Sri Lanka, she understands the challenges students face and specializes in visa
 processes, scholarships, and financial documentation.

          </p>
          {/* {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12"
            >
              <div className="cardImgContainer">
                <img
                  className="cardImg"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/id2.svg"
                  alt="Value Icon"
                />
              </div>
              <div className="cardText">
                <p className="text-blk cardHeading">Value</p>
                <p className="text-blk cardSubHeading">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
              </div>
            </div>
          ))}
          <a href="#">
            <button className="explore">Read more</button>
          </a> */}
        </div>

        <div className="imgContainer">
          <img
            className="blueDots"
            src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/aw3.svg"
            alt="background dots"
          />
          <img
            className="mainImg"
            src={maheshi}
            alt="Main"
          />
                <h1> Maheshi Pratibha Kasturiarchi</h1>

        </div>
       
      </div>
    </div>
     );
    };
    
    export default AboutUs;